import React from 'react';

// Pill toggle with a blue indicator that slides to the selected option.
export const SegmentedToggle = ({ options, value, onChange, ariaLabel }) => {
  const activeIndex = Math.max(
    0,
    options.findIndex((option) => option.value === value)
  );

  return (
    <div
      role="tablist"
      aria-label={ariaLabel}
      className="relative inline-grid rounded-full bg-jp-section border border-jp-outline/70 p-1"
      style={{ gridTemplateColumns: `repeat(${options.length}, minmax(0, 1fr))` }}
    >
      {/* Sliding indicator */}
      <span
        aria-hidden="true"
        className="absolute top-1 bottom-1 left-1 rounded-full border border-jp-accent bg-jp-accent/15 transition-transform duration-300 ease-out"
        style={{
          width: `calc((100% - 0.5rem) / ${options.length})`,
          transform: `translateX(${activeIndex * 100}%)`,
        }}
      ></span>

      {options.map((option) => {
        const isActive = option.value === value;
        return (
          <button
            key={option.value}
            type="button"
            role="tab"
            aria-selected={isActive}
            onClick={() => onChange(option.value)}
            className={`relative z-10 px-5 py-1.5 rounded-full text-xs font-bold uppercase tracking-wider transition-colors duration-300 focus:outline-none focus-visible:ring-2 focus-visible:ring-jp-accent ${
              isActive ? 'text-jp-accent-ink' : 'text-jp-muted hover:text-jp-ink'
            }`}
          >
            {option.label}
          </button>
        );
      })}
    </div>
  );
};

export default SegmentedToggle;
